export const OvalTheme = {
  DEFAULT: 'blue',
  RED: 'red',
} as const;
export type OvalTheme = typeof OvalTheme[keyof typeof OvalTheme];
